import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../common/Select";
import {
  getMyCaseload,
  getProgramUnitsConfig,
  getFormsySubmissionsForMultiple,
  getTeamCaseload,
  getCompliancyMyCaseload,
  getCompliancyProgramUnitCaseload,
} from "../services/soar";
import { getCompliancyNextDue } from "../services/compliancyService";
import { getFieldName } from "../../scripts/helperScripts";
import FormsTrackingClientProgram from "./FormsTrackingClientProgram";

function FormsTracking() {
  const isMountedRef = useRef(true);
  const [type, setType] = useState("Items Due");
  const [caseloadType, setCaseloadType] = useState("My Caseload");
  const [itemsDue, setItemsDue] = useState([]);
  const [clients, setClients] = useState([]);
  const [history, setHistory] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedForm, setSelectedForm] = useState("");
  const [selectedProgram, setSelectedProgram] = useState("");
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const [dischargedWindow, setDischargedWindow] = useState("30");
  const [units, setUnits] = useState([]);
  const [showRules, setShowRules] = useState(null);
  const location = useLocation();

  useEffect(() => {
    getProgramUnitsConfig(
      process.env.REACT_APP_ENVIRONMENT !== "Production"
        ? "SoarD365Base"
        : "SoarLive"
    ).then((response) => {
      if (response && isMountedRef.current) {
        setUnits(response.filter((u) => u.sor_compliancy));
      }
    });
  }, []);

  useEffect(() => {
    if (caseloadType === "My Caseload" && safyInfo !== null) {
      const toastId = toast.loading(
        `Getting tracking for ${safyInfo.user.displayName}...`,
        { type: toast.TYPE.INFO }
      );

      // get Caseload for user
      getCompliancyMyCaseload(safyInfo.user.email.split("@")[0]).then(
        (response) => {
          if (response && isMountedRef.current) {
            const records = response
              .filter(
                (program) =>
                  program.unit.sor_compliancy &&
                  program.care.ccx_expdate === undefined &&
                  (safyInfo.user.safyInfo.BusinessUnitIdName === "ccplive" ||
                    getFieldName(program.ccx_company) ===
                      safyInfo.user.safyInfo.BusinessUnitIdName)
              )
              .sort((a, b) => a.con.fullname.localeCompare(b.con.fullname));
            setClients(records);
            getFormsySubmissions(records, toastId);
          }
        }
      );
    } else {
      setClients([]);
    }
  }, [caseloadType]);

  useEffect(() => {
    if (selectedProgram !== "") {
      const toastId = toast.loading(
        `Getting tracking for ${selectedProgram}...`,
        { type: toast.TYPE.INFO }
      );
      getCompliancyProgramUnitCaseload(selectedProgram).then((response) => {
        if (response) {
          const records = response
            .filter(
              (program) =>
                program.ccx_admitdate &&
                program.unit.sor_compliancy &&
                (safyInfo.user.safyInfo.BusinessUnitIdName === "ccplive" ||
                  getFieldName(program.ccx_company) ===
                    safyInfo.user.safyInfo.BusinessUnitIdName)
            )
            .sort((a, b) => a.con.fullname.localeCompare(b.con.fullname));
          setClients(records);
          getFormsySubmissions(records, toastId);
        } else {
          setClients([]);
        }
      });
    }
  }, [selectedProgram]);

  const getFormsySubmissions = async (records, toastId) => {
    console.log("Get Records", records);
    getFormsySubmissionsForMultiple(
      records.map((c) => c.ccx_patient["#text"])
    ).then((response) => {
      if (response && isMountedRef.current) {
        console.log("Get History", response);
        setHistory(response);
      }
      toast.update(toastId, {
        render: `Caseload for ${safyInfo.user.displayName} loaded.`,
        type: toast.TYPE.SUCCESS,
        isLoading: false,
        autoClose: 5000,
        closeOnClick: true,
      });
    });
  };

  useEffect(() => {
    if (clients.length > 0 && Array.isArray(history) && history.length > 0) {
      console.log("History", history);
      let itemsDue = [];
      clients.forEach((program) => {
        const compliancyConfig = JSON.parse(
          program.unit.sor_compliancy
        ).compliancy;
        const compliancy = getCompliancyNextDue(
          compliancyConfig,
          program,
          history.filter(
            (h) =>
              h.ClientProgramId.toLowerCase() ===
              program.ccx_client_programid.replace(/[{}]/g, "").toLowerCase()
          )
        );
        // console.log("Compliancy", compliancy);
        if (compliancy?.length > 0) {
          compliancy.forEach((c) => {
            //FOR ROLLOUT ONLY SHOW TFC OUTCOMES FORMS
            if (c.name === "TFC Outcomes Form" || c.name === "SC TFC Outcomes")
              itemsDue.push(c);
          });
        }
      });
      itemsDue.sort((a, b) => new Date(a.due) - new Date(b.due));
      setItemsDue(itemsDue);
    }
  }, [clients, history]);

  const resetFilters = () => {
    setClients([]);
    setItemsDue([]);
    setSelectedProgram("");
    setSelectedClient("");
    setSelectedForm("");
  };

  return (
    <>
      <div className="h4">TFC Outcomes Tracking</div>
      <div className="row">
        <div className="col">
          <div className="border border-dark btn-group  mb-4">
            <button
              className={
                caseloadType === "My Caseload"
                  ? "btn btn-primary"
                  : "btn btn-light"
              }
              onClick={() => {
                setCaseloadType("My Caseload");
                resetFilters();
                setDischargedWindow("30");
              }}
            >
              My Caseload
            </button>
            <button
              className={
                caseloadType === "Program Unit"
                  ? "btn btn-primary"
                  : "btn btn-light"
              }
              onClick={() => {
                setCaseloadType("Program Unit");
                resetFilters();
                setDischargedWindow("");
              }}
            >
              Progam Unit
            </button>
          </div>
        </div>
        <div className="col">
          <div className="border border-dark btn-group  mb-4">
            <button
              className={
                type === "Items Due" ? "btn btn-primary" : "btn btn-light"
              }
              onClick={() => setType("Items Due")}
            >
              Items Due
            </button>
            <button
              className={
                type === "History" ? "btn btn-primary" : "btn btn-light"
              }
              onClick={() => setType("History")}
            >
              History
            </button>
          </div>
        </div>
        <div className="row">
          {caseloadType === "Program Unit" ? (
            <div className="col">
              <Select
                label="Filter by Program Unit"
                name="unit"
                options={units.map((u) => ({
                  _id: u.ccx_name,
                  name: u.ccx_name,
                  key: u.ccx_client_programid,
                }))}
                value={selectedProgram}
                onChange={({ currentTarget: input }) => {
                  setSelectedProgram(input.value);
                  setSelectedClient("");
                  setSelectedForm("");
                }}
              />
            </div>
          ) : null}
          <div className="col">
            <Select
              label="Filter by Client"
              name="client"
              options={[
                ...new Set(clients.map((c) => JSON.stringify(c.ccx_patient))),
              ].map((c) => ({
                _id: JSON.parse(c)["#text"],
                name: JSON.parse(c)["@name"],
              }))}
              value={selectedClient}
              onChange={({ currentTarget: input }) => {
                setSelectedClient(input.value);
              }}
            />
          </div>
          {/* <div className="col">
          <Select
            label="Filter by Form"
            name="form"
            options={[
              ...new Set(
                clients.flatMap((c) => {
                  const compliancyConfig = JSON.parse(
                    c["unit.sor_compliancy"]
                  ).compliancy;
                  return compliancyConfig.map((c) =>
                    JSON.stringify({
                      _id: c.formId,
                      name: c.form,
                    })
                  );
                })
              ),
            ].map((c) => ({
              _id: JSON.parse(c)._id,
              name: JSON.parse(c).name,
            }))}
            value={selectedForm}
            onChange={({ currentTarget: input }) => {
              setSelectedForm(input.value);
            }}
          />
        </div> */}
          <div className="col">
            <Select
              label="Discharged Window"
              name="window"
              options={[
                { _id: "7", name: "7" },
                { _id: "30", name: "30" },
                { _id: "60", name: "60" },
                { _id: "90", name: "90" },
                { _id: "120", name: "120" },
                { _id: "180", name: "180" },
              ]}
              value={dischargedWindow}
              onChange={({ currentTarget: input }) => {
                setDischargedWindow(input.value);
              }}
            />
          </div>
        </div>
        {type === "History"
          ? clients
              .filter(
                (c) =>
                  c.ccx_patient["#text"].includes(selectedClient) &&
                  (c.ccx_dischargedate === undefined ||
                    new Date(c.ccx_dischargedate["@date"]) >
                      new Date().setDate(
                        new Date().getDate() - dischargedWindow
                      ))
              )
              .map((program) => {
                return (
                  <FormsTrackingClientProgram
                    key={`${program.ccx_patient["#text"]}-${program.ccx_client_programid}`}
                    clientProgram={program}
                    history={history.filter(
                      (h) =>
                        h.ClientProgramId.toLowerCase() ===
                        program.ccx_client_programid
                          .replace(/[{}]/g, "")
                          .toLowerCase()
                    )}
                    filteredForm={selectedForm}
                  />
                );
              })
          : itemsDue
              .filter(
                (i) =>
                  i.client["#text"].includes(selectedClient) &&
                  i.formId.includes(selectedForm) &&
                  (i.clientProgram.ccx_dischargedate === undefined ||
                    new Date(i.clientProgram.ccx_dischargedate["@date"]) >
                      new Date().setDate(
                        new Date().getDate() - dischargedWindow
                      ))
              )
              .map((i, index) => (
                <div
                  key={`${i.client["#text"]}-${i.clientProgram.ccx_client_programid}-${i.formId}-${index}`}
                  className={`row rounded border bg-safy2-5 m-1 p-2 ${
                    new Date() > new Date(i.due) ? "border-danger border-2" : ""
                  }`}
                >
                  <Link
                    className="col-2 btn btn-primary fw-bold text-white"
                    id={i.client["#text"].replace(/[{}]/g, "")}
                    title="Open Client Record"
                    to={`/client/${i.client["#text"].replace(/[{}]/g, "")}`}
                    state={{
                      previousPath: location.pathname,
                    }}
                  >
                    {i.client["@name"]}
                  </Link>
                  <div className="col-4">
                    <div className="fw-bold">{i.clientProgram.ccx_name}</div>
                    <div
                      className={
                        i.clientProgram.ccx_dischargedate
                          ? "text-danger fw-bold"
                          : ""
                      }
                    >
                      {`Admit: ${i.clientProgram.ccx_admitdate["@date"]} ${
                        i.clientProgram.ccx_dischargedate
                          ? ` - Discharge: ${i.clientProgram.ccx_dischargedate["@date"]}`
                          : ""
                      }`}
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fw-bold">
                      {i.name}
                      {showRules === i.clientProgram.ccx_client_programid ? (
                        <i
                          className="fas fa-info-circle text-danger mb-2 ms-2"
                          onClick={() => setShowRules(null)}
                        />
                      ) : (
                        <i
                          className="fas fa-info-circle text-primary mb-2 ms-2"
                          onClick={() =>
                            setShowRules(i.clientProgram.ccx_client_programid)
                          }
                        />
                      )}
                      {new Date(i.implemented) >
                      new Date(i.clientProgram.ccx_admitdate["@date"]) ? (
                        <i
                          className="fas fa-asterisk fa-xs text-danger ms-2"
                          title="Form Implemented After Admission"
                          onClick={() =>
                            toast.warning(
                              "Form Implemented After Client Admission"
                            )
                          }
                        />
                      ) : null}
                    </div>
                    <div>{i.type}</div>
                    {showRules === i.clientProgram.ccx_client_programid ? (
                      <div>
                        <div className="row text-white">
                          {`Initial Due: ${i.rules.initial.days} days after ${i.rules.initial.event}`}
                        </div>
                        <div className="row text-white">
                          {`Subsequent Due: ${i.rules.subsequent.days} days after ${i.rules.subsequent.event}`}
                        </div>
                        {i.rules.discharge ? (
                          <div className="row text-white">
                            {`Discharge Due: ${i.rules.discharge.days} days after ${i.rules.discharge.event}`}
                          </div>
                        ) : null}
                        <div className="row text-white">
                          {`Implemented: ${i.rules.implemented} `}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="col-2 fw-bold">
                    <div>{i.due}</div>
                    <div></div>
                  </div>
                  <div className="col-1">
                    <Link
                      title={`Add ${i.name}`}
                      className=" text-primary"
                      style={{ textDecoration: "none" }}
                      to={`../${i.path}${
                        i.path !== "form" &&
                        i.versionNumber !== undefined &&
                        i.versionNumber !== "1"
                          ? `v${i.versionNumber}`
                          : ""
                      }/${
                        i.formVersionId
                      }/${i.clientProgram.con.contactid.replace(/[{}]/g, "")}`}
                      state={{
                        client: i.clientProgram.ccx_patient,
                        clientProgram: {
                          "#text": i.clientProgram.ccx_client_programid,
                          "@name": i.clientProgram.ccx_name,
                        },
                        SubmissionId: "",
                        initialData: {},
                        comments: "",
                        createdBy: {
                          "#text": safyInfo.user.safyInfo.SystemUserId,
                          "@name": safyInfo.user.displayName,
                        },
                        tab: "forms",
                        previousPath: location.pathname,
                        selectedProgram: i.clientProgram,
                      }}
                    >
                      <i className="fas fa-plus-circle fa-xl text-primary pt-4" />
                    </Link>
                  </div>
                </div>
              ))}
      </div>
    </>
  );
}

export default FormsTracking;
